import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import TemplateDefault from "../../components/template-default";
import Card from "../../components/card";
import Button from "../../components/button";
import {FaPlusSquare} from "react-icons/fa";
import InputForm from "../../components/input-form";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../utils/localization-ag-grid";
import TechnicianService from "../../services/technician-service";
import {buildAccentInsensitiveColDef, setAccentInsensitiveQuickFilter} from "../../utils/ag-grid-quick-filter";

const Technician = () => {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "SISTEMA INTERNO";
    }, []);

    const {data: technician} = useQuery({
        queryFn: () => TechnicianService.list().then(({data}) => data),
        queryKey: ['technician']
    });

    const [columnDefs] = useState([
        {field: "id", headerName: "ID", width: 40},
        {field: "name", headerName: "Nome", flex:1}
    ]);

    const gridRef = useRef();

    const defaultColDef = useMemo(() => {
        return buildAccentInsensitiveColDef({resizable: false});
    }, []);

    const onFilterTextBoxChanged = useCallback(({target}) => {
        setAccentInsensitiveQuickFilter(gridRef, target.value);
    }, []);

    const onCellClicked = (cell) => navigate(`/technician/form/${cell.data.id}`);

    return (
        <TemplateDefault title="Técnicos">
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">
                    <Button col="col-span-2" onClick={() => navigate("/technician/form")}>
                        <FaPlusSquare/> Novo técnico
                    </Button>

                    <InputForm id="search" col="col-span-10" label="Pesquisar" type="search"
                               onChange={onFilterTextBoxChanged}/>

                </div>

                <div className={"ag-theme-quartz grid mt-4"} style={{height: "calc(100vh - 185px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={technician ?? []}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        pagination
                        paginationPageSize={500}
                        paginationPageSizeSelector={[10, 50, 100, 500]}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        gridOptions={{localeText: LocalizationAgGrid}}
                        onCellClicked={onCellClicked}
                    />
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default Technician;
